var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/~/core-js/internals/well-known-symbol-wrapped.js
// module id = 832
// module chunks = 118